<template lang="pug">
include /mixins
+b.cart-conflict-wrap
  +e.title.P {{ _('Учесть для закупки') }}
  +e.variant
    d-control-multiselect(
      :options='trips'
      :custom-label='obj => obj.props && obj.props.title'
      v-model='value'
      :preselect-first='true'
      :allow-empty='false'
      @input='setTrip'
    )
  slot(:value='value')
    +b.cart-conflict(v-if='value && value.id === 0 && !conflicts.length')
      +e.title.P {{ _('Обратите внимание') }}
      +e.text.P {{ _('Если Вы выбираете «Учесть товары этого предложения в поездку», все скидки, кэшбэки и бонусы могут быть автоматически отменены для тех товаров, которые входят в закупку по условиям выбранной поездки.') }}
    +b.cart-conflict(v-if='conflicts.length')
      +e.title.P {{ _('Обратите внимание') }}
      +e.text.P {{ _('В вашем заказе есть специальные предложения, которые совпадают с условиями закупки. Вы можете выбрать, какие из товаров учитывать в закупку выбранной поездки.') }}
      +e.btn
        +b.tt-button--bordered_main.--fixed-h.--auto.A(
          @click='openModal'
        )
          +e.title.SPAN {{ _('Выбрать') }}
</template>

<script>
import { mapActions } from 'vuex'

import { actualTripsListResource } from '@api/vendor.service'

import {
  addTripToCart,
} from '@api/cart.service'

import ConflictResolve from '@app/Cart/ConflictResolve.vue'

export default {
  name: 'CartConflicts',
  props: {
    conflicts: {
      type: Array,
      required: true,
    },
    trip: {
      type: Object,
    },
  },
  data() {
    return {
      trips: [],
      value: this.trip || null,
      initOption: {
        id: 0,
        props: {
          title: this._('Не участвовать'),
        },
      },
    }
  },
  watch: {
    trip: {
      immediate: true,
      handler(newVal) {
        this.value = newVal
      },
    },
  },
  mounted() {
    this.getTrips()
  },
  methods: {
    ...mapActions('cart', [
      'changeCart', 'getCart',
    ]),
    async setTrip() {
      await addTripToCart.execute({}, { id: this.value && this.value.id ? this.value.id : null })
      await this.getCart()
    },
    async getTrips() {
      const { data: { items } } = (await actualTripsListResource.execute({ registered_as_potential: true }))
      items.unshift(this.initOption)
      this.trips = items
      if (!this.value) this.value = this.trips[0]
    },
    async updateStrategy(data) {
      await this.changeCart({ data: { calc_strategy_campaigns: data }, retrieve: true })
    },
    openModal() {
      const pr = arg => new Promise((resolve, reject) => {
        if (arg) {
          resolve(arg)
          return
        }
        reject(new Error('Promise is rejected'))
      }).then(res => {
        this.updateStrategy(res)
      })
      this.$modal.show(
        ConflictResolve,
        {
          trip: this.trip,
          conflicts: this.conflicts,
          promise: pr,
        }, {
          height: 'auto',
          classes: ['cart-modal'],
          adaptive: true,
          scrollable: true,
        }
      )
    },
  },
}
</script>
